import { withFormik } from 'formik';
import createCreateForm from '../createForm/createCreateForm';

export default createCreateForm({ withFormik });
